import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";

import requireAuthentication from "../../HOC/requireAuthentication";
import { getAuth } from "../../actions/authActions";
import { getCompanies } from "../../actions/introActions";
import { showModal } from "../../actions/modalActions";
import Grid from "../Grid/Grid";
import Skeleton from "react-loading-skeleton";

const Statement = styled.p`
  letter-spacing: 1.6px;
  font-family: Lato;
  color: #666;
  font-size: 16px;
  text-align: center;
  line-height: normal;
  margin-bottom: 40px;
  margin-top: 20px;
`;

const SkeletonDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-row-gap: 50px;
  justify-content: space-between;
  @media (max-width: 420px) {
    margin: 0px auto;
  }
`;

class CompanyList extends React.Component {
  async componentDidMount() {
    if (!this.props.user) this.props.getAuth();

    this.props.getCompanies();
  }

  render() {
    if (this.props.companies === null || this.props.companies === undefined) {
      return (
        <SkeletonDiv>
          <Skeleton height={370} width={300} />
          <Skeleton height={370} width={300} />
          <Skeleton height={370} width={300} />
        </SkeletonDiv>
      );
    }

    switch (this.props.companies.length) {
      case 0:
        return (
          <div>
            <br />
            <Statement>No matches yet. Please check back later.</Statement>
          </div>
        );
      case undefined:
        return <Redirect to={"/"} />;
      default:
        return (
          <div>
            <Statement>
              Please read through each company's information, select the
              position you are interested in, and write a brief statement of
              interest.
            </Statement>
            <Grid companies={this.props.companies} intros={this.props.intros} />
            <p
              className="disclaimer-content"
              style={{
                marginTop: "100px",
                color: "#3a3a3a",
                textAlign: "center",
                lineHeight: 1.2,
                fontSize: 14,
                letterSpacing: 1,
              }}
            >
              <span style={{ textDecoration: "underline" }}>Please Note:</span>{" "}
              The companies we are working with are recruiting quickly and we
              are frequently updating the list above to reflect the latest.
              Thus, if you no longer see a company that was once here, they are
              most likely on hold. With that in mind, please express interest in
              the companies you like ASAP and let your Associate know if you
              have any questions.
            </p>
          </div>
        );
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    companies: state.intros.companies,
    intros: state.intros.intros,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getAuth,
      getCompanies,
      showModal,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(requireAuthentication(CompanyList));



// WEBPACK FOOTER //
// ./src/components/pages/CompanyList.js